export default "__VITE_ASSET__8212b36b__"